import moment from "moment";
import * as globalUtils from "../../../helpers/utils";

import reduxStore from "../../../redux/store";
import config from "./config";

export const buildTravelProposalRequest = (data, language) => {
    const { travelDetails, applicants } = data;

    let restApplicants = [];
    if (applicants.applicants && applicants.applicants.length) {
        restApplicants = applicants.applicants.map((ele) => {
            return {
                premiumAmount: null,
                dob: ele.dobGreg,
                idnumber: ele.nationalId,
                relationCode: "Applicant",
                name: globalUtils.isArabic(language)
                    ? applicants.self.fullNameArabic
                    : applicants.self.fullNameEnglish,
            };
        });
    }

    return {
        duration: moment(travelDetails.returnDate).diff(
            moment(travelDetails.deptDate),
            "hours"
        ),
        PromotionalFactors: [
            {
                UTMTag: "",
                promotionalCode: travelDetails.promoCode || "",
                openFieldOne: "",
                openFieldTwo: "",
            },
        ],
        returnDate: travelDetails.returnDate,
        featureCode: "",
        productCode: "ST",
        upgradePlan: false,
        promoCode: "",
        ApplicantDetails: [
            {
                premiumAmount: null,
                dob: applicants.self.dobGreg,
                idnumber: applicants.self.nationalId,
                relationCode: "Self",
                name: globalUtils.isArabic(language)
                    ? applicants.self.fullNameArabic
                    : applicants.self.fullNameEnglish,
            },
            ...restApplicants,
        ],
        coverCode: travelDetails.productCode,
        languageCode: globalUtils.getOneLetterLanguageCode(language),
        deptDate: travelDetails.deptDate,
    };
};

export const showMobile = () => {
    const width = window.innerWidth;
    //////     // console.log('Width: ', width);
    const responsiveBreak = 1025;
    return width >= responsiveBreak;
};

export const buildFlightProposalRequest = (data, language) => {
    const { applicants, ...restData } = data;

    let passegers = [];
    if (applicants.applicants && applicants.applicants.length) {
        passegers = applicants.applicants.map((ele) => {
            return {
                idNumber: ele.nationalId,
                relationCode: "APT",
            };
        });
    }

    return {
        applicationRef: "SPFD",
        carrierFsCode: restData.carrierFsCode,
        coverOptionCode: null,
        departureDate: restData.departureDate,
        flightNumber: restData.flightNumber,
        lang: language,
        passengerList: [
            {
                idNumber: applicants.self.nationalId,
                relationCode: "APT",
            },
            ...passegers,
        ],
        proposalCode: null,
    };
};

export const buildTravelQoutationRequest = (data, language) => {
    const { travelDetails, applicants, selectedFeatures } = data;

    let mySelectedFeature = [
        {
            featureCode: "",
            featureDescription: null,
            featurePrice: null,
            price: null,
        },
    ];
    if (selectedFeatures && selectedFeatures.length) {
        mySelectedFeature = selectedFeatures.map((ele) => {
            return {
                featureCode: ele.featureCode,
                featureDescription: ele.featureDescription,
                featurePrice: ele.price,
                price: ele.price,
            };
        });
    }

    return {
        CreateQuotationRequest: {
            productCode: "ST",
            coverCode: travelDetails.productFeatureCode,
            idNO: travelDetails.nationalId,
            tripDepartureDate: travelDetails.deptDate,
            tripReturnDate: travelDetails.returnDate,
            languageCode: globalUtils.getOneLetterLanguageCode(language),
            consumerTrackingId: travelDetails.nationalId,
            consumerInitiatedTimeStamp: new Date(),
            fursanID: travelDetails.alfursanId || "",
            FeatureDetails: mySelectedFeature,
            DependentsDetails: applicants.applicants.map((ele) => {
                return {
                    // "relationship": "Wife",
                    idNO: ele.nationalId,
                    dOB: ele.dobGreg,
                    firstNameinEnglish: ele.firstNameEnglish,
                    middleNameinEnglish: ele.midNameEnglish,
                    lastNameinEnglish: ele.lastNameEnglish,
                    nationality: ele.nationalityCode,
                    emailAddress: null,
                    gender: null,
                    occupation: null,
                    passportNumber: null,
                };
            }),
            AddressDetails: {
                additionalNumber: "2066898",
                addressCity: "5",
                addressRegion: "2",
                buildingNumber: "2526",
                district: "Al Faisaliyah Dist.",
                mailingAddress: "WA",
                poBox: "23442",
                postalCode: "23442",
                street: "Al Batha",
                unitNumber: null,
                waselPostalCode: "23442",
            },
            PromotionalFactors: [
                {
                    promotionalCode: travelDetails.promoCode || "",
                    UTMTag: "",
                    openFieldOne: "",
                    openFieldTwo: "",
                },
            ],
            returnCity: null,
            channelCode: "2",
            departureCity: null,
            ApplicantDetails: {
                idNO: applicants.self.nationalId,
                dOB: applicants.self.dobGreg,
                firstNameinEnglish: applicants.self.firstNameEnglish,
                middleNameinEnglish: applicants.self.midNameEnglish,
                lastNameinEnglish: applicants.self.lastNameEnglish,
                nationality: applicants.self.nationalityCode,
                gender: applicants.self.gender,
                emailAddress: travelDetails.email,
                mobileNumber: travelDetails.contactNumber,
                occupation: applicants.self.occupation,
                passportNumber: null,
                relationship: "self",
            },
        },

    };
};

export const buildFlightQoutationRequest = (data, language) => {
    const { travelDetails, flightProposal, applicants, flightCovered } = data;

    // ////     // console.log(travelDetails);
    const coveredItem = flightProposal.quoteList.find(
        (ele) => ele.periodCovered == flightCovered
    );
    return {
        fursanID: travelDetails.alfursanId || "",
        applicationRef: "SPFD",
        mapApprovalDoc: {
            qtnDetails: {
                AMLMatchStatus: null,
                applicantDetails: null,
                isPEPFlag: "0",
                isRoyalFamily: null,
                isTawuniyaBOD: null,
                LOB: null,
                payerDetails: null,
                payerFlag: null,
                PEPLink: null,
                policyHolderDetails: null,
                policyHolderSameFlag: null,
                quotationNum: null,
                RoyalFamilylink: null,
                TawuniyaBODlink: null,
            },
        },
        lang: language,
        passengerDetails: [
            {
                addressTyp: "WA",
                bankCode: travelDetails.bankCode || "",
                cityCode: "38",
                countryCode: "SA",
                dob: moment(applicants.self.dobGreg).format("DD/MM/YYYY"),
                email: travelDetails.email,
                employer: "Empty",
                firstName: applicants.self.firstNameEnglish,
                genderCode: applicants.self.gender,
                iban: travelDetails.iban || "",
                idNumber: applicants.self.nationalId,
                incomeSource: "Empty",
                lastName: applicants.self.lastNameEnglish,
                middleName: applicants.self.midNameEnglish,
                mobile: travelDetails.contactNumber,
                nationalityCode: applicants.self.nationalityCode,
                occupationCode: null,
                placeOfBirth: "Empty",
                poboxCode: "12345",
                politicalEmployer: null,
                politicalOccupation: null,
                politicalRank: null,
                politicalRelevantName: null,
                politicallyExposedCode: "0",
                postalCode: "12345",
                regionCode: "1",
                relationCode: "APT",
                ticketNumber: null,
            },
        ],
        proposalCode: flightProposal.proposalCode,
        quoteDetails: {
            arrivalAirportIataCode:
                flightProposal.flightDetalis.arrivalAirportIataCode,
            coverOptionCode: coveredItem.coverOptionCode,
            departureAirportIataCode:
                flightProposal.flightDetalis.departureAirportIataCode,
            periodCovered: flightCovered,
        },
    };
};

export const buildBundleQoutationRequest = (
    travelDetails,
    flightDelayQuotation,
    travelQuotation
) => {
    const flightTotal = flightDelayQuotation.paymentDetails.find(
        (ele) => ele.amountType === "GRNDTOT"
    );
    return {
        idNumber: travelDetails.nationalId,
        totalAmount: `${Number(
            +travelQuotation.GrandTotal + +flightTotal.amountValue
        ).toFixed(2)}`,
        quotes: [
            {
                quotationNumber: travelQuotation.QuotationNumber,
                amount: travelQuotation.GrandTotal,
                lob: "TR",
            },
            {
                quotationNumber: flightDelayQuotation.quotationCode,
                amount: flightTotal.amountValue,
                lob: "FD",
            },
        ],
    };
};

export const isSME = () => {
    const personalFormDetails = reduxStore.getState().motor.personalFormDetails;
    return personalFormDetails && personalFormDetails.isSME;
};

export const checkMissingData = (vehicle) => {
    return (
        !vehicle?.deductible ||
        !vehicle?.vehicleValue ||
        !vehicle?.modelCode ||
        !vehicle?.yearOfManufacture
    );
};

export const getInceptionDate = (date) => {
    return moment(date, "YYYY-MM-DD").isAfter(moment())
        ? moment(date, "YYYY-MM-DD").add(1, "d").format("DD-MM-YYYY")
        : moment().add(1, "d").format("DD-MM-YYYY");
};

// dataObj = {customerDetails,vehicleDetails}
// productCode : one of ["ALL","MotorImtiazeTP","PRMotorImtiazeSP","PRMotorImtiazeCO"];
export const buildProposalRequest = (quotationInfo, productCode) => {
    const obj = {
        customerDetails: {
            policyHolder: [quotationInfo.customerDetails],
        },
        vehicleDetails: {
            vehicleDetailsArray: [quotationInfo.vehicleDetails],
        },
    };

    let cleanedJson = JSON.parse(JSON.stringify(obj));
    try {
        cleanedJson.requestGeneratedTime = null;
        cleanedJson.upgradeDetails = {
            cancelDate: null,
            policyNumber: null,
        };
        delete cleanedJson.priceDetails;
        delete cleanedJson.policyTermsUrl;
        delete cleanedJson.premium;
        delete cleanedJson.resultCode;
        delete cleanedJson.resultMessage;
        if (cleanedJson.customerDetails && cleanedJson.customerDetails.policyHolder)
            cleanedJson.customerDetails.policyHolder.forEach((policyHolder) => {
                let city = policyHolder.homeWaselCityCode;
                let region = policyHolder.homeWaselRegionCode;
                let gender = policyHolder.genderCode;
                Object.keys(policyHolder).forEach(function (key) {
                    if (key.endsWith("Name") || key.endsWith("Code"))
                        delete policyHolder[key];
                    if (policyHolder[key] && policyHolder[key].includes("--"))
                        policyHolder[key] = policyHolder[key].replace("--", "-");
                });
                delete policyHolder["driverType"];
                delete policyHolder["isPolicyHolder"];
                policyHolder.homeWaselCityCode = city;
                policyHolder.homeWaselRegionCode = region;
                policyHolder.genderCode = gender;
            });
        cleanedJson.vehicleDetails.vehicleDetailsArray.forEach((element) => {
            element.plateTypeCode = element.plateType;
            if (
                !(
                    element.vehicleValue ||
                    element.vehicleValue == "" ||
                    Number(element.vehicleValue) == 0
                )
            )
                element.vehicleValue = element.minValue;
            Object.keys(element).forEach(function (key) {
                if (element[key] == "-1") element[key] = null;
            });
            delete element.colorName;
            delete element.makeName;
            delete element.usageTypeName;
            delete element.priceDetails;
            delete element.modelMake;
            delete element.plateTypeName;
            delete element.plateType;
            delete element.insurancePeriod;
            delete element.minValue;
            delete element.maxValue;
            delete element.modelName;
            delete element.ncdValue;
            if (productCode == config.productCode.co && productCode != "undefined")
                element.deductibleForUnifiedForm = element.deductible;
            else if (
                productCode == config.productCode.sp &&
                productCode != "undefined"
            ) {
                element.deductibleForUnifiedForm = element.deductible;
                element.deductible = "1250";
            } else if (
                productCode == config.productCode.tp &&
                productCode != "undefined"
            ) {
                element.deductibleForUnifiedForm = element.deductible;
                element.deductible = null;
            }
            if (
                element.vehicleDriverDetails &&
                element.vehicleDriverDetails.vehicleDriverDetailsArray
            ) {
                element.vehicleDriverDetails.vehicleDriverDetailsArray.forEach(
                    (driver) => {
                        Object.keys(driver).forEach(function (key) {
                            if (key.endsWith("Name")) delete driver[key];
                        });
                        Object.keys(driver).forEach(function (key) {
                            if (driver[key] == "-1") driver[key] = null;
                        });
                        delete driver["alfursan_id"];
                        delete driver["addressType"];
                        delete driver["bankCode"];
                        delete driver["cityCode"];
                        delete driver["childUnderSixteen"];
                        delete driver["email"];
                        delete driver["fax"];
                        delete driver["homelongitude"];
                        delete driver["homeaddrlatitude"];
                        delete driver["hijriBirthyear"];
                        delete driver["iban"];
                        delete driver["officelongitude"];
                        delete driver["officelatitude"];
                        delete driver["officeAddressGeneral"];
                        delete driver["p_pep_employer"];
                        delete driver["p_is_pep"];
                        delete driver["p_pep_occupation"];
                        delete driver["phoneOne"];
                        delete driver["phoneTwo"];
                        delete driver["p_aml_employer_details"];
                        delete driver["preferredLanguageCode"];
                        delete driver["p_pep_rank"];
                        delete driver["p_pep_relevant_name"];
                        delete driver["p_aml_birth_place"];
                        delete driver["preferredContactMethodCode"];
                        delete driver["p_aml_income_source"];
                        delete driver["poBox"];
                        delete driver["regionCode"];
                        delete driver["zipCode"];
                        delete driver["idNumber"];
                        delete driver["yob"];
                        delete driver["saudiDrivingLicenseExpCode"];
                        delete driver["saudiDrivingLicenseExpName"];
                        delete driver["driverRelationCode"];
                        delete driver["driverRelationName"];
                        delete driver["otherCountriesLicenses"];
                        delete driver["homelongitude"];
                        delete driver["homelatitude"];
                        delete driver["hijDob"];
                    }
                );
                var mainDriver =
                    element.vehicleDriverDetails.vehicleDriverDetailsArray.find(
                        (driver) => {
                            return driver.driverType == "MD";
                        }
                    );
                element.majorDrivingRegionCode = mainDriver.homeWaselRegionCode;
                element.majorDrivingCityCode = mainDriver.homeWaselCityCode;
            }
            if (element.selectedFeatures && element.selectedFeatures.selectedFeatures)
                element.selectedFeatures.selectedFeatures.forEach((feature) => {
                    delete feature.featureText;
                });
        });
        cleanedJson.demandRequestType = "";
        cleanedJson.endorsementType = cleanedJson.endorsementCode;
        delete cleanedJson.endorsementCode;
        cleanedJson.specialSchemeCode = "STANDARD";
        cleanedJson.productCode = productCode;
        cleanedJson.requiredInceptionDate = moment(
            cleanedJson.requiredInceptionDate,
            "YYYY-MM-DD"
        ).format("DD-MM-YYYY");
    } catch (err) {
        console.error(err);
    }
    return cleanedJson;
};

// dataObj = {customerDetails,vehicleDetails}
// productCode : one of ["ALL","MotorImtiazeTP","PRMotorImtiazeSP","PRMotorImtiazeCO"];
export const buildQuotationAPIRequest = (quotationInfo, productCode) => {
    const obj = {
        customerDetails: {
            policyHolder: [quotationInfo.customerDetails],
        },
        vehicleDetails: {
            vehicleDetailsArray: [quotationInfo.vehicleDetails],
        },
    };
    let cleanedJson = JSON.parse(JSON.stringify(obj));
    cleanedJson.productCode = productCode;
    cleanedJson.requiredInceptionDate = moment(
        cleanedJson.requiredInceptionDate,
        "YYYY-MM-DD"
    ).format("DD-MM-YYYY");
    cleanedJson.vehicleDetails.vehicleDetailsArray.forEach((element) => {
        element.plateTypeCode = element.plateType;
        element.majorDrivingRegionCode =
            cleanedJson.customerDetails.policyHolder[0].regionCode;
        element.majorDrivingCityCode =
            cleanedJson.customerDetails.policyHolder[0].cityCode;
        delete element.colorName;
        delete element.minValue;
        delete element.plateType;
        delete element.maxValue;
        delete element.modelName;
        delete element.ncdValue;
        delete element.makeName;
        if (
            element.vehicleDriverDetails &&
            element.vehicleDriverDetails.vehicleDriverDetailsArray
        )
            element.vehicleDriverDetails.vehicleDriverDetailsArray.forEach(
                (driver) => {
                    delete driver.zipCode;
                    delete driver.addressType;
                    delete driver.preferredLanguageCode;
                    delete driver.cityCode;
                    delete driver.regionCode;
                    delete driver.email;
                    delete driver.preferredLanguageName;
                    delete driver["p_pep_employer"];
                    delete driver["p_is_pep"];
                    delete driver["p_pep_occupation"];
                    delete driver["phoneOne"];
                    delete driver["phoneTwo"];
                    delete driver["p_aml_employer_details"];
                    delete driver["preferredLanguageCode"];
                    delete driver["p_pep_rank"];
                    delete driver["p_pep_relevant_name"];
                    delete driver["p_aml_birth_place"];
                    delete driver["preferredContactMethodCode"];
                    delete driver["p_aml_income_source"];
                    delete driver["poBox"];
                    delete driver["childUnderSixteen"];
                    delete driver["regionName"];
                    delete driver["cityName"];
                    delete driver["alfursan_id"];
                    delete driver["yob"];
                    delete driver["idNumber"];
                    delete driver["otherCountriesLicenses"];
                    delete driver["alfursan_id"];
                    delete driver["hijriBirthyear"];
                    delete driver["homelongitude"];
                    delete driver["homelatitude"];
                    delete driver["officeAddressGeneral"];
                    delete driver["makeName"];
                    delete driver["twitterName"];
                    delete driver["bankCode"];
                    delete driver["officelongitude"];
                    delete driver["bankName"];
                    delete driver["homeaddrlatitude"];
                    delete driver["iban"];
                    delete driver["officelatitude"];
                    delete driver["fax"];
                    delete driver["preferredContactMethodName"];
                    delete driver["hijDob"];
                }
            );
        if (productCode == config.productCode.tp) {
            element.deductibleForUnifiedForm = element.deductible;
            element.deductible = null;
        } else if (productCode == config.productCode.sp) {
            element.deductibleForUnifiedForm = element.deductible;
            element.deductible = "1250";
        } else element.deductibleForUnifiedForm = element.deductible;
    });
    if (cleanedJson.customerDetails && cleanedJson.customerDetails.policyHolder)
        cleanedJson.customerDetails.policyHolder.forEach((policyHolder) => {
            delete policyHolder["claimsIn5YearsCode"];
        });
    return cleanedJson;
};

export const proposalRequestPreparation = ({ vehicleDetails, ...rest }) => {
    return {
        vehicleDetails: {
            vehicleDetailsArray: [vehicleDetails]
        },
        ...rest,
        "endorsementType": "PSL",
        "requiredInceptionDate": "21-06-2022",
        "requestGeneratedTime": null,
        "demandRequestType": "",
        "languageCode": "E",
        "upgradeDetails": {
            "cancelDate": null,
            "policyNumber": null
        },
        "specialSchemeCode": "STANDARD"
    }
}

export const vehicleObjectPrepareForGetProposal = (vehicle) => {
    const vehicleDriverDetails = vehicleDriverPrepareForGetProposal();
    const { plateType, makeName, modelName, ncdValue, ...rest } = vehicle;
    delete rest.colorName;
    delete rest.amount;
    delete rest.dedAmount;
    delete rest.model;
    delete rest.title;
    const carDetails = {
        ...rest,
        vehicleValue: String(vehicle.vehicleValue),
        yearOfManufacture: String(vehicle.yearOfManufacture),
        plateTypeCode: "1", // Unknown error happen!
        agencyRepairRequired: "N", // Repair Type
        usageTypeCode: "PRIVATE",
        majorDrivingRegionCode: "1",
        majorDrivingCityCode: "38",
        vehicleTransferFlag: "N",
        parkingLocationCode: "MOTOR_AR_PARKING",
        transmissionCode: "1",
        mileagePerYearCode: "2",
        currentMileage: "100000",
        parkingLocationName: "",
        transmissionName: "Automatic",
        deductibleForUnifiedForm: null,
        milagePerYearName: "Between 10000 and 25000.",
        colorCode: "11",
        vehicleDriverDetails: {
            vehicleDriverDetailsArray: vehicleDriverDetails
        },
    }
    if (vehicle?.selectedFeatures?.length) {
        Object.assign(carDetails, {
            selectedFeatures: {
                selectedFeatures: vehicle?.selectedFeatures ?? []
            }
        })
    }
    return carDetails;
}

const vehicleDriverPrepareForGetProposal = () => {
    return [
        {
            "officeSelfUnitNumber": "",
            "gregDob": "01-01-2000",
            "educationCode": "GRD",
            "maritalStatusCode": "1",
            "officeWaselPostalCode": "24351",
            "nationalityCode": "7",
            "roadConvictionsCode": "NIL",
            "medicalConditionsCode": "1",
            "homeWaselRegionCode": "1",
            "officeWaselAdditionalNumber": "7267",
            "driverRelationCode": "NOR",
            "childUnderSixteenCode": "3",
            "homeSelfUnitNumber": "",
            "officeWaselBuildingNumber": "3773",
            "officeWaselRegionCode": "1",
            "licenseTypeCode": "1",
            "mobile": "+966582639666",
            "isPolicyHolder": "Y",
            "officeWaselCityCode": "38",
            "driverType": "",
            "homeWaselBuildingNumber": "3773",
            "genderCode": "1",
            "occupationCode": "26",
            "claimsIn5YearsCode": "0",
            "driverUsagePercentageCode": "100",
            "homeWaselAdditionalNumber": "7267",
            "homeWaselCityCode": "38",
            "homeWaselPostalCode": "24351",
            "accidentsIn5YearsCode": "0",
            "IDNO": "2445547918"
        }
    ]
}

export const customerDetailsPrepareForGetProposal = (customer) => {
    const {
        zipCode,
        preferredContactMethodName,
        nationalityName,
        maritalStatusCode,
        officeWaselPostalCode,
        nationalityCode,
        engLastName,
        araLastName,
        homeWaselEngStreetName,
        homeWaselEngDistrictName,
        araMidName,
        araFirstName,
        maritalStatusName,
        engMidName,
        officeWaselAraStreetName,
        homeWaselRegionName,
        officeWaselRegionName,
        cityCode,
        engFullName,
        occupationName,
        regionName,
        educationCode,
        bankName,
        officeWaselCityName,
        officeWaselEngStreetName,
        homeWaselCityName,
        regionCode,
        cityName,
        officeWaselEngDistrictName,
        educationName,
        engFirstName,
        homeWaselAraStreetName,
        araFullName,
        bankCode,
        homeWaselAraDistrictName,
        officeWaselRegionCode,
        preferredLanguageName,
        twitterName,
        preferredContactMethodCode,
        genderName,
        officeWaselCityCode,
        occupationCode,
        homeWaselPostalCode,
        officeWaselAraDistrictName,
        preferredLanguageCode,
        ...rest
    } = customer;
    rest['childUnderSixteen'] = '0';
    return {
        "policyHolder": [rest]
    }
}

export const getGender = (genderCode) => {
    return genderCode === "2" || genderCode === "F" ? "female" : "male";
}

export const MotorInsuranceCompaniesDatalayerDictionary = {
    [globalUtils.BUSINESS_LINE_PATHS.DEFAULT]: {
        step_name_value: "motor_policy_new_",
        item_name_value: "Motor Insurance New"
    },
    [globalUtils.BUSINESS_LINE_PATHS.BSF]: {
        step_name_value: "BSF_motor_insurance_",
        item_name_value: "BSF Motor Insurance"
    },
    [globalUtils.BUSINESS_LINE_PATHS.STC]: {
        step_name_value: "STC_motor_insurance_",
        item_name_value: "STC Motor Insurance"
    },
    [globalUtils.BUSINESS_LINE_PATHS.MOM]: {
        step_name_value: "MOM_motor_insurance_",
        item_name_value: "Mohim Motor Insurance"
    },
    [globalUtils.BUSINESS_LINE_PATHS.LUCID]: {
        step_name_value: "LUCID_motor_insurance_",
        item_name_value: "Lucid Motor Insurance"
    },
    [globalUtils.BUSINESS_LINE_PATHS.SNB]: {
        step_name_value: "SNB_motor_insurance_",
        item_name_value: "SNB Motor Insurance"
    },
}
